import React from 'react';
import './style.css';
import AdaptiveClientLogo from '../AdaptiveClientLogo';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useGlobal } from '../../GlobalContext';

const { REACT_APP_URL_API } = process.env;

const LogoClienteFacilities = ({ disableNavigation = false }) => {
  const { cliente_id } = useParams();
  const location = useLocation();
  const { data } = useGlobal();

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  const logo = localStorage.getItem('cliente_logo');

  if (!logo) return null;

  const image = (
    <AdaptiveClientLogo
      src={`${REACT_APP_URL_API}${logo}`}
      alt="Logo Cliente"
    />
  );

  return (
    <div className="logo-client-wrapper">
      {disableNavigation ? image : (
        <Link to={`/${cliente_id}/${location.search}`}>{image}</Link>
      )}
    </div>
  );
};

export default LogoClienteFacilities;
